module.exports = __webpack_public_path__ + "static/eval2-7f948b319aae131a6513742fe192747e.pdf";